
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.386 10.518c0-.758-.614-1.372-1.372-1.372h-1.945c.562-1.406.603-2.558.599-2.928 0-.04.009-.184.009-.216v-.064c-.041-1.335-.45-1.743-.975-1.938a.974.974 0 00-.974.974v.098c-.005.333-.474 1.022-.474 1.022L9.678 9.71l-.06.074-1.088 2.908 1.088 4.51c0 .136.11.247.247.247h6.732a.927.927 0 00.917-.787c.264-1.73.872-5.748.872-6.145z","fill":"#FFC998"}}),_c('path',{attrs:{"d":"M8.84 18H6.39a.777.777 0 01-.776-.776V9.867c0-.429.348-.776.777-.776h2.45c.429 0 .777.347.777.776v7.357A.777.777 0 018.84 18z","fill":"#3D60F6"}})])
          )
        }
      }
    